export default __webpack_public_path__ + "static/media/form-bg-sm.09c8ad9b.svg";